import React, { useEffect, useState } from "react";
import startPage from "../images/live.svg";
import { RaddLogo } from "../icons/icons";
import { Transition, Chat, LiveBar } from "../components/common";
import moment from "moment";
import "../scss/pages/LiveStream.scss";
import { Close } from "../icons/icons";
import io from "socket.io-client";
import { connect, useDispatch } from "react-redux";
import { getLiveStream } from "../redux/actions/livesActions";
import AgoraRTC from "agora-rtc-sdk-ng";
import { ExitLiveStreamPopup } from "../components/modal/ExitLiveStreamPopup";
import { EndedStream } from "../components/modal/EndedStream";
import LiveStreamProducts from "../components/common/LiveStreamProducts";
import { InfoPreviewStartStream } from "../components/common/InfoPreviewStartStream";
import { singInWithCred } from "../redux/actions/authActions";
import MobileChat from "../components/common/ShooperLive/Chat";

const socketOptions = {
  secure: true,
  reconnection: true,
  reconnectionDelay: 1000,
  timeout: 15000,
  pingTimeout: 15000,
  pingInterval: 45000,
  query: { framespersecond: 15, audioBitrate: 22050 },
  transports: ["websocket", "polling"],
};

let socket = null;

const LiveStream = ({ match, history, idToken, getLiveStream, orgInfo }) => {
  const dispatch = useDispatch();
  const [started, setStarted] = useState(false);
  const [isStream, setIsStaream] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const [error2, setError2] = useState(false);
  const [barOpen, setBarOpen] = useState(false);
  const [messages, setMessage] = useState([]);
  const [data, setData] = useState({});
  const [viewers, setViewers] = useState(0);
  const [isMuted, setIsMuted] = useState(false);
  const [mic, setMic] = useState(null);
  const [exitPopupStream, setExitPopupStream] = useState(false);
  const [endStream, setEndStream] = useState(false);
  const client = AgoraRTC.createClient({ mode: "live", codec: "vp8" });
  const sendMessage = (text, isRemove, id) => {
    if (isRemove === "add") {
      socket.emit("chat_message", {
        name: data.name,
        time: moment().format("HH:mm"),
        text,
        id: Math.floor(Math.random() * 100000),
        action: "add",
      });
    } else if (isRemove === "remove") {
      socket.emit("chat_message", {
        id: id,
        action: "remove",
      });
    } else if (isRemove === "edit") {
      socket.emit("chat_message", {
        id: id,
        text,
        action: "edit",
      });
    }
  };

  const switchProductFunc = ({ id, status }) => {
    socket.emit("switch_products", {
      id: id,
      status: status,
    });
  };

  useEffect(() => {
    socket = io.connect("lives.raddcontent.com", socketOptions);
    getLiveStream({ authToken: idToken, liveId: match.params.id }).then(
      (res) => {
        setLoaded(true);
        if (res.error) {
          setError(true);
          return;
        }
        setData(res.result);
        // const socket = io.connect("http://localhost:3001/", socketOptions);
        navigator.getUserMedia =
          navigator.mediaDevices.getUserMedia ||
          navigator.mediaDevices.mozGetUserMedia ||
          navigator.mediaDevices.msGetUserMedia ||
          navigator.mediaDevices.webkitGetUserMedia;
        if (!navigator.getUserMedia) {
          fail("No getUserMedia() available.");
          setError2(true);
        }

        try {
          if (!MediaRecorder) {
            fail("No MediaRecorder available.");
            setError2(true);
          }
        } catch {
          setError2(true);
        }

        socket.emit("join_room", match.params.id);

        socket.on("connect_timeout", (timeout) => {
          console.log("state on connection timeout= " + timeout);
        });
        socket.on("update_count", (m) => {
          console.log("online - " + m);
          setViewers(m - 1);
        });
        socket.on("chat_message", (m) => {
          console.log("chat -" + m);
          setMessage((prev) => [...prev, { name: m.name, text: m.text }]);
        });
        socket.on("error", (error) => {
          console.log("state on connection error= " + error);
        });

        socket.on("send_message", (m) => {
          if (m.action === "add") {
            setMessage((prev) => [
              ...prev,
              { name: m.name, text: m.text, time: m.time, id: m.id },
            ]);
          } else if (m.action === "remove") {
            setMessage((prev) => prev.filter((el) => el.id !== m.id));
          } else if (m.action === "edit") {
            setMessage((prev) => {
              return prev.map((el) => {
                if (el.id === m.id) {
                  el.text = m.text;
                }
                return el;
              });
            });
          } else {
            setMessage((prev) => [
              ...prev,
              {
                name: m.name,
                text: m.text,
                time: moment().format("HH:mm"),
                id: Math.floor(Math.random() * 100000),
              },
            ]);
          }
        });

        socket.on("switch_products", (data) => {
          console.log("switch product id -", data);
        });

        socket.on("connect_error", function () {
          console.log("state on connection error");
        });

        socket.on("message", function (m) {
          console.log("recv server message", m);
        });

        socket.on("fatal", function (m) {
          console.log("fatal socket error!!", m);
        });

        socket.on("disconnect", function (reason) {
          console.log("state disconec");
        });
      }
    );

    return () => {
      socket.close();
    };

    // eslint-disable-next-line
  }, []);

  function fail(str) {
    alert(
      str +
        "\nUnable to access the camera Please ensure you are on HTTPS and using Firefox or Chrome."
    );
  }

  useEffect(() => {
    if (!idToken) {
      dispatch(
        singInWithCred({
          email: "invite@raddcontent.com",
          password: "invite",
        })
      );
    }
  }, [dispatch, idToken]);

  const startStream = async () => {
    setStarted(true);

    client.setClientRole("host");
    await client.join(data.appID, data.channelName, data.token);
    const [microphoneTrack, cameraTrack] =
      await AgoraRTC.createMicrophoneAndCameraTracks();

    const output_video2 = document.getElementById("video_stream");
    const button = document.getElementById("start-stream");
    const buttonMobile = document.getElementById("start-stream-mobile");
    const button2 = document.getElementById("stop_stream");
    const button3 = document.getElementById("exitStream");

    setMic(microphoneTrack);
    cameraTrack.play(output_video2);

    const startStreamLive = async () => {
      microphoneTrack.setEnabled(true);
      cameraTrack.setEnabled(true);
      await client.publish([microphoneTrack, cameraTrack]);
      button2.style.display = "block";
      button.style.display = "none";
      microphoneTrack.setEnabled(true);
      cameraTrack.setEnabled(true);
      setIsStaream(true);
    };

    button.onclick = startStreamLive;
    buttonMobile.onclick = startStreamLive;

    button2.onclick = () => {
      setExitPopupStream(true);
    };

    button3.onclick = async () => {
      await client.unpublish([microphoneTrack, cameraTrack]);
      microphoneTrack.setEnabled(false);
      cameraTrack.setEnabled(false);
      microphoneTrack.close();
      cameraTrack.close();
      client.leave();

      button.style.display = "inline-block";
      button2.style.display = "none";
      setIsStaream(false);
      setStarted(false);

      setExitPopupStream(false);
      setEndStream(true);
    };
  };

  const setMicro = (val) => {
    if (mic) {
      mic.setEnabled(val);
    }
  };

  return loaded ? (
    !error && !error2 ? (
      <Transition withbutton>
        <div className="livestream__page">
          <ExitLiveStreamPopup
            exitPopupStream={exitPopupStream}
            setExitPopupStream={setExitPopupStream}
          />
          <EndedStream endStream={endStream} orgInfo={orgInfo} />
          <div
            style={{
              visibility: started ? "visible" : "hidden",
            }}
            className="video_over"
          >
            <div className="video_over--wrapper">
              <div className="video_over--wrapper__block">
                <div
                  className={`video__header desk${isStream ? " streamed" : ""}`}
                >
                  <div className="stop__button" id="stop_stream">
                    Stop LIVE session
                  </div>

                  {/* <div className="start__button" id="start_stream">
                  Start LIVE session
                </div> */}
                </div>
                <LiveStreamProducts
                  products={data.products}
                  storyId={data.id}
                  socket={socket}
                  switchProductFunc={switchProductFunc}
                />
                {isStream ? (
                  <div className="video_container video-live-stream-container ">
                    <div id="video_stream"></div>
                    {data.products &&
                      data.products.filter((el) => !el.error).length !== 0 && (
                        <LiveBar
                          isOpen={barOpen}
                          setOpen={(val) => {
                            setBarOpen(val);
                          }}
                          avatar={data.influencer}
                          title={data.name}
                          name={data.name}
                          products={data.products.filter((el) => !el.error)}
                          storyId={data.id}
                          barId={"22"}
                          socket={socket}
                          switchProductFunc={switchProductFunc}
                        />
                      )}
                    <div className="author">
                      <div className="avatar">
                        <div
                          className="profile__avatar"
                          style={{
                            backgroundImage: `url("${data.influencer}")`,
                          }}
                        />
                      </div>
                      <div className="info">
                        <div className="more">{data.name}</div>
                        <div className="name">
                          <svg
                            width="17"
                            height="10"
                            viewBox="0 0 17 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginRight: 8 }}
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M1.00134 5.00217L1.0009 5.00045L1.00134 4.99873C1.00553 4.98228 1.02265 4.915 1.09211 4.78669C1.17289 4.63748 1.30041 4.44945 1.47656 4.23409C1.82799 3.80444 2.34695 3.29774 2.99618 2.81348C4.29956 1.8413 6.0722 1 8.00183 1C9.93147 1 11.7041 1.8413 13.0075 2.81348C13.6567 3.29774 14.1757 3.80444 14.5271 4.23409C14.7033 4.44945 14.8308 4.63748 14.9116 4.78669C14.981 4.915 14.9981 4.98228 15.0023 4.99873L15.0028 5.00045L15.0023 5.00217C14.9981 5.01862 14.981 5.0859 14.9116 5.21421C14.8308 5.36342 14.7033 5.55146 14.5271 5.76681C14.1757 6.19646 13.6567 6.70316 13.0075 7.18742C11.7041 8.1596 9.93147 9.0009 8.00183 9.0009C6.0722 9.0009 4.29956 8.1596 2.99618 7.18742C2.34695 6.70316 1.82799 6.19646 1.47656 5.76681C1.30041 5.55146 1.17289 5.36342 1.09211 5.21421C1.02265 5.0859 1.00553 5.01862 1.00134 5.00217ZM8.00183 0C5.78832 0 3.81004 0.958883 2.39829 2.0119C1.68996 2.54024 1.1103 3.1024 0.702507 3.60097C0.499039 3.84972 0.331795 4.09064 0.21271 4.31061C0.102512 4.51416 0 4.75963 0 5.00045C0 5.24127 0.102512 5.48674 0.21271 5.69029C0.331795 5.91026 0.499039 6.15118 0.702507 6.39993C1.1103 6.8985 1.68996 7.46066 2.39829 7.989C3.81004 9.04202 5.78832 10.0009 8.00183 10.0009C10.2153 10.0009 12.1936 9.04202 13.6054 7.989C14.3137 7.46066 14.8934 6.8985 15.3012 6.39993C15.5046 6.15118 15.6719 5.91026 15.791 5.69029C15.9012 5.48674 16.0037 5.24127 16.0037 5.00045C16.0037 4.75963 15.9012 4.51416 15.791 4.31061C15.6719 4.09064 15.5046 3.84972 15.3012 3.60097C14.8934 3.1024 14.3137 2.54024 13.6054 2.0119C12.1936 0.958883 10.2153 0 8.00183 0ZM5.68896 4.99996C5.68896 3.80389 6.70511 2.79969 8.00215 2.79969C9.29919 2.79969 10.3153 3.80389 10.3153 4.99996C10.3153 6.19602 9.29919 7.20023 8.00215 7.20023C6.70511 7.20023 5.68896 6.19602 5.68896 4.99996ZM8.00215 1.79969C6.19183 1.79969 4.68896 3.21339 4.68896 4.99996C4.68896 6.78652 6.19183 8.20023 8.00215 8.20023C9.81247 8.20023 11.3153 6.78652 11.3153 4.99996C11.3153 3.21339 9.81247 1.79969 8.00215 1.79969Z"
                              fill="#F8F9FA"
                            />
                          </svg>
                          {viewers}
                        </div>
                      </div>
                    </div>
                    <div className="mobile">
                      <MobileChat
                        messages={messages}
                        sendMessage={(data) => sendMessage(data, "add")}
                        setBarOpen={setBarOpen}
                        name={data.name}
                        isMuted={isMuted}
                        setIsMuted={setIsMuted}
                        org={data.orgName}
                        setMicro={setMicro}
                        mic={mic}
                        isStreamer
                      />
                    </div>
                    <div
                      className="mute-button-stream desk"
                      onClick={() => {
                        setMicro(isMuted);
                        setIsMuted((m) => !m);
                      }}
                    >
                      {!isMuted ? (
                        <svg
                          width="21"
                          height="22"
                          viewBox="0 0 21 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          id="mute-btn"
                        >
                          <path
                            d="M1.75 8.75123C1.75 7.96819 2.38478 7.33341 3.16781 7.33341H5.60943C5.94248 7.33341 6.26489 7.21617 6.52014 7.00225L9.33574 4.64251C9.7971 4.25585 10.5 4.58387 10.5 5.18583V16.8143C10.5 17.4163 9.7971 17.7443 9.33574 17.3577L6.52014 14.9979C6.26489 14.784 5.94248 14.6667 5.60943 14.6667H3.16781C2.38478 14.6667 1.75 14.032 1.75 13.2489V8.75123Z"
                            fill="white"
                          />
                          <path
                            d="M13.125 7.33325C13.125 7.33325 14.4375 8.70825 14.4375 10.9999C14.4375 13.2916 13.125 14.6666 13.125 14.6666"
                            stroke="white"
                            stroke-width="1.27603"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M15.75 3.66675C15.75 3.66675 18.55 6.41675 18.55 11.0001C18.55 15.5834 15.75 18.3334 15.75 18.3334"
                            stroke="white"
                            stroke-width="1.27603"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      ) : (
                        <svg
                          width="21"
                          height="20"
                          viewBox="0 0 18 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ marginTop: 2 }}
                          id="unmute-btn"
                        >
                          <path
                            d="M3 5.08448C3 4.30144 3.63478 3.66667 4.41781 3.66667H6.85943C7.19248 3.66667 7.51489 3.54943 7.77014 3.3355L10.5857 0.975763C11.0471 0.589097 11.75 0.917118 11.75 1.51909V13.1476C11.75 13.7495 11.0471 14.0776 10.5857 13.6909L7.77014 11.3312C7.51489 11.1172 7.19248 11 6.85943 11H4.41781C3.63478 11 3 10.3652 3 9.58219V5.08448Z"
                            fill="white"
                          />
                          <path
                            d="M3 14L16 1"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M1 18L17 2"
                            stroke="#313232"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      )}
                    </div>
                    <div
                      className="close mobile"
                      id="close_stream"
                      onClick={() => setExitPopupStream(true)}
                    >
                      <Close />
                    </div>
                  </div>
                ) : (
                  <div className="video_container video-live-stream-container ">
                    <div id="video_stream"></div>
                    {data.products &&
                      data.products.filter((el) => !el.error).length !== 0 && (
                        <LiveBar
                          isOpen={barOpen}
                          setOpen={(val) => {
                            setBarOpen(val);
                          }}
                          avatar={data.influencer}
                          title={data.name}
                          name={data.name}
                          products={data.products.filter((el) => !el.error)}
                          storyId={data.id}
                          barId={"22"}
                        />
                      )}
                    <div
                      className="start__button mobile"
                      id="start-stream-mobile"
                    >
                      Start LIVE now
                    </div>
                    {/* <div className="author">
                  <div className="avatar">
                    <div
                      className="profile__avatar"
                      style={{
                        backgroundImage: `url("${data.influencer}")`,
                      }}
                    />
                  </div>
                  <div className="info">
                    <div className="more">{data.name}</div>
                    <div className="name">
                      <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 8 }}>
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M1.00134 5.00217L1.0009 5.00045L1.00134 4.99873C1.00553 4.98228 1.02265 4.915 1.09211 4.78669C1.17289 4.63748 1.30041 4.44945 1.47656 4.23409C1.82799 3.80444 2.34695 3.29774 2.99618 2.81348C4.29956 1.8413 6.0722 1 8.00183 1C9.93147 1 11.7041 1.8413 13.0075 2.81348C13.6567 3.29774 14.1757 3.80444 14.5271 4.23409C14.7033 4.44945 14.8308 4.63748 14.9116 4.78669C14.981 4.915 14.9981 4.98228 15.0023 4.99873L15.0028 5.00045L15.0023 5.00217C14.9981 5.01862 14.981 5.0859 14.9116 5.21421C14.8308 5.36342 14.7033 5.55146 14.5271 5.76681C14.1757 6.19646 13.6567 6.70316 13.0075 7.18742C11.7041 8.1596 9.93147 9.0009 8.00183 9.0009C6.0722 9.0009 4.29956 8.1596 2.99618 7.18742C2.34695 6.70316 1.82799 6.19646 1.47656 5.76681C1.30041 5.55146 1.17289 5.36342 1.09211 5.21421C1.02265 5.0859 1.00553 5.01862 1.00134 5.00217ZM8.00183 0C5.78832 0 3.81004 0.958883 2.39829 2.0119C1.68996 2.54024 1.1103 3.1024 0.702507 3.60097C0.499039 3.84972 0.331795 4.09064 0.21271 4.31061C0.102512 4.51416 0 4.75963 0 5.00045C0 5.24127 0.102512 5.48674 0.21271 5.69029C0.331795 5.91026 0.499039 6.15118 0.702507 6.39993C1.1103 6.8985 1.68996 7.46066 2.39829 7.989C3.81004 9.04202 5.78832 10.0009 8.00183 10.0009C10.2153 10.0009 12.1936 9.04202 13.6054 7.989C14.3137 7.46066 14.8934 6.8985 15.3012 6.39993C15.5046 6.15118 15.6719 5.91026 15.791 5.69029C15.9012 5.48674 16.0037 5.24127 16.0037 5.00045C16.0037 4.75963 15.9012 4.51416 15.791 4.31061C15.6719 4.09064 15.5046 3.84972 15.3012 3.60097C14.8934 3.1024 14.3137 2.54024 13.6054 2.0119C12.1936 0.958883 10.2153 0 8.00183 0ZM5.68896 4.99996C5.68896 3.80389 6.70511 2.79969 8.00215 2.79969C9.29919 2.79969 10.3153 3.80389 10.3153 4.99996C10.3153 6.19602 9.29919 7.20023 8.00215 7.20023C6.70511 7.20023 5.68896 6.19602 5.68896 4.99996ZM8.00215 1.79969C6.19183 1.79969 4.68896 3.21339 4.68896 4.99996C4.68896 6.78652 6.19183 8.20023 8.00215 8.20023C9.81247 8.20023 11.3153 6.78652 11.3153 4.99996C11.3153 3.21339 9.81247 1.79969 8.00215 1.79969Z"
                          fill="#F8F9FA"
                        />
                      </svg>
                      {viewers}
                    </div>
                  </div>
                </div> */}
                  </div>
                )}
                {isStream ? (
                  <div className="desk-chat-wrapper desk">
                    <Chat
                      messages={messages}
                      sendMessage={sendMessage}
                      setBarOpen={setBarOpen}
                      name={data.name}
                      isMuted={isMuted}
                      setIsMuted={setIsMuted}
                      org={data.orgName}
                      setMicro={setMicro}
                    />
                  </div>
                ) : (
                  <InfoPreviewStartStream started={started} data={data} />
                )}
              </div>
            </div>
          </div>
          <div className="logo">
            <RaddLogo />
          </div>
          <div className="livestream__subtitle">
            Your LIVE stream is scheduled for:{" "}
            {moment(data.time).format("dddd Do MMMM, h:mm A")}{" "}
          </div>
          <div className="livestream__title">
            Before you enter the LIVE stream let’s begin with a quick preview
          </div>
          <div className="livestream-wrapper">
            <img
              src={startPage}
              alt="livestream__page"
              className="livestream-wrapper__image"
            />
          </div>
          <div className="page__button">
            <div className="accent__button" onClick={startStream}>
              Start preview
            </div>
          </div>
        </div>
      </Transition>
    ) : error2 ? (
      <Transition withbutton>
        <div className="livestream__page">
          <div className="logo">
            <RaddLogo />
          </div>
          <div className="livestream__title nonexist">
            Your devise not support live
          </div>
          <div className="page__button">
            <div
              className="accent__button"
              onClick={() => {
                history.push(`/`);
              }}
            >
              OK
            </div>
          </div>
        </div>
      </Transition>
    ) : (
      <Transition withbutton>
        <div className="livestream__page">
          <div className="logo">
            <RaddLogo />
          </div>
          <div className="livestream__title nonexist">
            Live stream ends or doesn't exist
          </div>
          <div className="page__button">
            <div
              className="accent__button"
              onClick={() => {
                history.push(`/`);
              }}
            >
              OK
            </div>
          </div>
        </div>
      </Transition>
    )
  ) : null;
};

const mapStateToProps = (state) => {
  const auth = state.auth.toJS();
  let { idToken, orgInfo } = auth;

  return {
    idToken,
    orgInfo,
  };
};

const mapDispatchToProps = {
  getLiveStream,
};

export default connect(mapStateToProps, mapDispatchToProps, null)(LiveStream);
